var React = require('react');

function IconFullscreenInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1"},React.createElement("g",{"id":"icon-fullscreen","transform":"translate(2.000000, 2.000000)"},[React.createElement("polygon",{"id":"Stroke-1","points":"1.5 19.5 6 19.5 6 22.5 -1.5 22.5 -1.5 15 1.5 15","key":0}),React.createElement("polygon",{"id":"Stroke-3","points":"18.5 15 21.5 15 21.5 22.5 14 22.5 14 19.5 18.5 19.5","key":1}),React.createElement("polygon",{"id":"Stroke-5","points":"18.5 1.5 14 1.5 14 -1.5 21.5 -1.5 21.5 6 18.5 6","key":2}),React.createElement("polygon",{"id":"Stroke-7","points":"1.5 1.5 1.5 6 -1.5 6 -1.5 -1.5 6 -1.5 6 1.5","key":3})])));
}

IconFullscreenInline.defaultProps = {"width":"24px","height":"25px","viewBox":"0 0 24 25","version":"1.1"};

module.exports = IconFullscreenInline;

IconFullscreenInline.default = IconFullscreenInline;
